const AUTH_LOCAL_STORAGE_KEY = "cr-auth-key";
import { refreshToken } from "../layouts/authentication/_request";
import axios from "axios";
const getAuthLocal = () => {
  if (!localStorage) {
    return;
  }

  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);

  if (!lsValue) {
    return;
  }

  try {
    const auth = JSON.parse(lsValue);
    if (auth) {
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};

const setAuthLocal = (auth) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE SAVE ERROR", error);
  }
};

const removeAuthLocal = () => {
  if (!localStorage) {
    return;
  }
  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE REMOVE ERROR", error);
  }
};

const setupAxios = (saveAuthData, logout) => {
  if (!axios || typeof axios.interceptors !== "object") {
    return;
  }

  axios.defaults.headers.Accept = "application/json";
  try {
    axios.interceptors.request.use(
      function (config) {
        const auth = getAuthLocal();
        if (auth && auth.accessToken) {
          config.headers.Authorization = `Bearer ${auth.accessToken}`;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  } catch (error) {
    console.error("Error setting up request interceptor:", error);
    return;
  }

  try {
    axios.interceptors.response.use(
      async (response) => {
        if (!!response.data?.message && !response.data?.success) {
          if (response.status === 403) {
            window.location.href = "/";
            logout();
          }
        }
        if (response.status === 401) {
          const newToken = await refreshAuthLogic(response);
          if (!newToken) {
            window.location.href = "/";
            logout();
            return;
          }
          if (response.config.url.includes("/api/v1/verify-token")) {
            const parseData = JSON.parse(response.config.data);
            parseData.accessToken = newToken;
            response.config.data = JSON.stringify(parseData);
          }
          response.config.headers["Authorization"] = "Bearer " + newToken;
          return new Promise((resolve) => {
            resolve(axios(response.config));
          });
        }
        return response;
      },
      (err) => {
        return Promise.reject(err.message);
      }
    );
  } catch (error) {
    console.error("Error setting up response interceptor:", error);
    return;
  }

  const refreshAuthLogic = async (response) => {
    const lsRefreshToken = getAuthLocal()?.refreshToken;
    if (lsRefreshToken) {
      const tokenRefreshResponse = await refreshToken({ refreshToken: lsRefreshToken });
      if (tokenRefreshResponse.data.data) {
        saveAuthData(tokenRefreshResponse.data.data.tokens);
        return tokenRefreshResponse.data.data.tokens.accessToken;
      } else {
        logout();
        window.location.href = "/";
        return null;
      }
    } else {
      logout();
      window.location.href = "/";
      return null;
    }
  };
};

const setGtmCode = (gtmCode) => {
  if (!localStorage) {
    return;
  }

  localStorage.setItem("gtmCode", gtmCode);
};

const getGtmCode = () => {
  if (!localStorage) {
    return;
  }

  const gtmCode = localStorage.getItem("gtmCode");
  if (
    !gtmCode ||
    gtmCode.trim().toLowerCase() === "null" ||
    gtmCode.trim().toLowerCase() === "undefined"
  ) {
    return undefined;
  }
  return gtmCode || undefined;
};

export {
  setupAxios,
  getAuthLocal,
  setAuthLocal,
  removeAuthLocal,
  AUTH_LOCAL_STORAGE_KEY,
  getGtmCode,
  setGtmCode,
};
